import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
      if (!data.openConfirmationModal)
        return {
          title: t('message.title.success.save.chemical.product'),
          type: 'success'
        };
      else return false;
    case types.SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_FAILURE:
      return {
        title: t('message.title.error.save.chemical.product'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.DELETE_CHEMICAL_PRODUCT_SUCCESS:
      return {
        title: t('message.title.success.delete.chemical.product'),
        type: 'success'
      };
    case types.DELETE_CHEMICAL_PRODUCT_FAILURE:
      let title =
        data.message == 'message.error.delete.chemical.product.is.used'
          ? 'message.title.error.delete.chemical.product.is.used'
          : 'message.title.error.delete.chemical.product';
      return {
        title: t(title),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.GET_CHEMICAL_PRODUCT_FAILURE:
      return {
        title: t('message.title.error.get.chemical.product'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.CLONE_CHEMICAL_PRODUCT_FAILURE:
      return {
        title: t('message.title.error.clone.chemical.product'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.GET_CHEMICAL_PRODUCT_INITIAL_DATA_FAILURE:
      return {
        title: t('message.title.error.get.chemical.product.initial.data'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };

    default:
      return false;
  }
};
